export const CHANGE_TYPE = "SETTINGS/CHANGE_TYPE";
export const CHANGE_TEXT = "SETTINGS/CHANGE_TEXT";
export const CHANGE_HEADER_TEXT = "SETTINGS/CHANGE_HEADER_TEXT";
export const CHANGE_LIFE_TIME = "SETTINGS/CHANGE_LIFE_TIME";
export const CHANGE_SHOW_FROM = "SETTINGS/CHANGE_SHOW_FROM";
export const CHANGE_HIDE_TO = "SETTINGS/CHANGE_HIDE_TO";
export const CHANGE_BG_COLOR = "SETTINGS/CHANGE_BG_COLOR";
export const CHANGE_FONT_COLOR = "SETTINGS/CHANGE_FONT_COLOR";
export const CHANGE_ICON_COLOR = "SETTINGS/CHANGE_ICON_COLOR";
export const CHANGE_MARGIN = "SETTINGS/CHANGE_MARGIN";
export const CHANGE_PADDING = "SETTINGS/CHANGE_PADDING";
export const CHANGE_ANIMATION_TYPE = "SETTINGS/CHANGE_ANIMATION_TYPE";
export const CHANGE_CONTAINER_POSITION = "SETTINGS/CHANGE_CONTAINER_POSITION";
